import React, { useState } from 'react';

/**
 * ResearcherIntro
 * - Full Introduction tab content component.
 * - Moves static HTML from routes/Researcher.jsx into this component.
 * - Props: active (boolean), className (extra), record (researcher detail record), loading (optional)
 */
export default function ResearcherIntro({ active, className = '', record, loading = false }) {
  const [viewImage, setViewImage] = useState(null);
  const base = `${active ? 'active' : 'hidden'} pt-[50px] lg:pt-[60px]`;
  const introText = (() => {
    try {
      const t = record?.introduction;
      if (t == null) return '';
      const s = String(t).trim();
      return s;
    } catch (e) {
      return '';
    }
  })();
  const educationText = (() => {
    try {
      const t = record?.education;
      if (t == null) return '';
      const s = String(t).trim();
      return s.replace(/(?:\r\n|\r|\n)/g, '<br>');
    } catch (e) {
      return '';
    }
  })();
  const careerText = (() => {
    try {
      const t = record?.career;
      if (t == null) return '';
      const s = String(t).trim();
      return s.replace(/(?:\r\n|\r|\n)/g, '<br>');
    } catch (e) {
      return '';
    }
  })();

  return (
    <div className={`${base} ${className}`.trim()}>
      <div>
        <h3 className="mb-4 text-[18px] font-bold leading-[100%]">Introduction</h3>
        {introText ? (
          <div className="text-[14px] text-[#6C7687] leading-[140%] lg:text-[15px]" dangerouslySetInnerHTML={{ __html: introText }} />
        ) : (
          <div className="py-9 text-center text-[13px] font-semibold leading-[100%] border border-[#E4E8F1] rounded-[12px]">
            Introduction not provided.
          </div>
        )}
      </div>

      <div className="mt-[50px] lg:mt-[60px]">
        <h3 className="mb-4 text-[18px] font-bold leading-[100%] lg:mb-6">Educational History</h3>
        {educationText ? (
          <div className="text-[14px] text-[#6C7687] leading-[140%] lg:text-[15px]" dangerouslySetInnerHTML={{ __html: educationText }} />
        ) : (
          <div className="py-9 text-center text-[13px] font-semibold leading-[100%] border border-[#E4E8F1] rounded-[12px]">
            Education history not provided.
          </div>
        )}
      </div>

      <div className="mt-[50px] lg:mt-[60px]">
        <h3 className="mb-4 text-[18px] font-bold leading-[100%] lg:mb-6">Career</h3>
        {careerText ? (
          <div className="text-[14px] text-[#6C7687] leading-[140%] lg:text-[15px]" dangerouslySetInnerHTML={{ __html: careerText }} />
        ) : (
          <div className="py-9 text-center text-[13px] font-semibold leading-[100%] border border-[#E4E8F1] rounded-[12px]">
            Career information not provided.
          </div>
        )}
      </div>

      <div className="mt-[50px] lg:mt-[60px]">
        <h3 className="mb-4 text-[18px] font-bold leading-[100%] lg:mb-6">Additional Images</h3>

        {loading && <div className="text-[14px] text-[#6C7687] leading-[140%] lg:text-[15px]">불러오는 중...</div>}

        {!loading && record?.images?.length > 0 && (
          <ul className="additional-img flex flex-wrap gap-3">
            {record.images.map((img, idx) => (
              <li
                key={idx}
                className="group w-[calc((100%-12px)/2)] aspect-square border border-[#E4E8F1] rounded-[12px] overflow-hidden cursor-pointer sm:w-[calc((100%-24px)/3)] xl:w-[calc((100%-36px)/4)] 2xl:w-[calc((100%-48px)/5)]"
                onClick={() => setViewImage(img)}
              >
                <img
                  src={img}
                  className="w-full h-full object-cover group-hover:scale-[1.1] transition duration-300"
                  alt={`additional ${idx + 1}`}
                />
              </li>
            ))}
          </ul>
        )}

        {!loading && (!record?.images || record.images.length === 0) && (
          <div className="py-9 text-center text-[13px] font-semibold leading-[100%] border border-[#E4E8F1] rounded-[12px]">
            No image provided.
          </div>
        )}

        {viewImage && (
          <>
            <div className="fixed inset-0 bg-[rgba(0,0,0,0.4)] z-100" onClick={() => setViewImage(null)} aria-hidden="true" />

            <div className="fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[95%] max-w-[1200px] h-[90vh] max-h-[900px] flex flex-col px-[40px] pb-[40px] pt-[30px] bg-white rounded-[12px] z-[101] lg:px-[60px] lg:pb-[60px] shadow-xl">
              <button className="self-end w-[18px] mb-[10px] cursor-pointer lg:mb-[14px] shrink-0" onClick={() => setViewImage(null)} aria-label="닫기">
                <img src={`${rmVars.themeUrl}images/clear-icon-333.png`} alt="close" />
              </button>

              <div className="flex-1 min-h-0 overflow-auto flex items-center justify-center">
                <a href={viewImage} target="_blank" rel="noreferrer noopener" className="block w-full h-full flex items-center justify-center cursor-pointer">
                  <img src={viewImage} className="max-w-full max-h-full object-contain" alt="img" />
                </a>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
